export default __webpack_public_path__ + "static/media/6.e9691f7d.svg";